import { IOrderPriority } from 'my-poppies-b2b-types';
import { CSSProperties } from 'react';

import { Container } from '@/components/Container';
import useTranslation from '@/hooks/useTranslation';

interface IOrderPriorityProps {
  priority: IOrderPriority;
  includeTitle?: boolean;
}

const SIZE: CSSProperties['width'] = 12;
const sizeEffective = `min(${SIZE}px, 3dvw)`;

export const OrderPriority = ({ priority, includeTitle = false }: IOrderPriorityProps) => {
  const t = useTranslation();
  const priorityColor: CSSProperties['backgroundColor'] = {
    LOW: 'green',
    MID: 'yellow',
    HIGH: 'red',
  }[priority];
  const Dot = () => (
    <Container
      sx={{
        margin: 0,
        width: sizeEffective,
        height: sizeEffective,
        minWidth: sizeEffective,
        minHeight: sizeEffective,
        backgroundColor: priorityColor,
        borderRadius: '50%',
      }}
    />
  );
  if (!includeTitle) {
    return <Dot />;
  }

  return (
    <Container sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
      <Dot />
      <Container sx={{ width: 'unset', margin: 0, marginLeft: '4px', flexGrow: 0 }}>
        {t(`order.priority.${priority}`)}
      </Container>
    </Container>
  );
};
